"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _validatePasswordPolicy = require("../../utils/validatePasswordPolicy");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordPolicyInfo = function PasswordPolicyInfo(_ref) {
  var intl = _ref.intl,
      policy = _ref.policy,
      children = _ref.children,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'right' : _ref$placement;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "PasswordPolicyInfo"
  }, /*#__PURE__*/_react.default.createElement(_antd.Popover, {
    placement: placement,
    trigger: "hover",
    content: Object.keys(policy || []).map(function (name) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: name,
        className: "PasswordPolicyInfo__text"
      }, (0, _validatePasswordPolicy.getPolicyError)(intl, policy)(name));
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "anchor"
  }, children || /*#__PURE__*/_react.default.createElement(_icons.InfoCircleOutlined, null))));
};

var _default = PasswordPolicyInfo;
exports.default = _default;